export default {
  parseDate (date, format) {
    if (format === undefined) return this.parseDefaultDate(date)
    return ''
  },
  parseDefaultDate (date, separator = null) {
    var originalDate = date
    date = new Date(originalDate + ' ')
    if (isNaN(date)) date = new Date(originalDate) // Condicional feita para tratamento de data com TIMEZONE
    var day = this.numberWithPadding(date.getDate())
    var month = this.numberWithPadding(date.getMonth() + 1)

    return day + (separator || '/') + month + (separator || '/') + date.getFullYear()
  },
  parseInternationalDate (date) {
    var originalDate = date
    date = new Date(originalDate + ' ')
    if (isNaN(date)) date = new Date(originalDate) // Condicional feita para tratamento de data com TIMEZONE
    var day = this.numberWithPadding(date.getDate())
    var month = this.numberWithPadding(date.getMonth() + 1)

    return date.getFullYear() + '-' + month + '-' + day
  },
  numberWithPadding (number) {
    var padding = '00'
    number = number.toString()
    return (padding.substring(0, padding.length - number.length) + number)
  }
}



// WEBPACK FOOTER //
// ./src/utils/date.js